import { FIELD_NAME_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { useCellInputFocus } from "PFComponents/table";
import { DecimalNumberInput } from "PFComponents/text/decimal_number_input";
import { useRef } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { MAX_HOURS_PER_WEEK } from "./utils";

export type AvailabilityCellProps = {
  rowIndex: number;
  colIndex: number;
  value: number | null;
  roleFormKey: RoleFormKey;
  weekRange: string;
  onChange: (value: number | undefined) => void;
  disabled?: boolean;
  error?: string;
  inputClassName?: string;
};

export const AvailabilityCell = ({
  rowIndex,
  colIndex,
  value,
  roleFormKey,
  weekRange,
  onChange,
  disabled,
  error,
  inputClassName
}: AvailabilityCellProps) => {
  const { t } = useTranslation("activities");
  const ref = useRef<HTMLInputElement>(null);
  const { inputFocusProps } = useCellInputFocus(ref, { rowIndex, colIndex });
  const roleName = useWatch({ name: `${roleFormKey}.${FIELD_NAME_KEY}` });
  const ariaLabel = t("engagementBlueprint.roleAvailabilityTitle", { roleName, weekRange });

  return (
    <DecimalNumberInput
      ref={ref}
      variant="table"
      controlledValue={value ?? undefined}
      onChange={onChange}
      max={MAX_HOURS_PER_WEEK}
      disabled={disabled}
      error={error}
      inputClassName={inputClassName}
      aria-label={ariaLabel}
      {...inputFocusProps}
    />
  );
};
